import React from 'react'
import Link from 'gatsby-link'
import { Container } from 'react-responsive-grid'
import { siteMetadata } from '../../gatsby-config'
import SiteNavi from '../components/SiteNavi'

import Cnotice from '../components/cookieInfo'

import '../additional_css/bootstrap.css'
import '../additional_css/icomoon.css'
import '../additional_css/animate-custom.css'
import '../additional_css/terminal.css'

import '../additional_css/main.css'

class Template extends React.Component {
  componentDidMount() {
    const WOW = require('wowjs')
    this.wow = new WOW.WOW()
    this.wow.init()
  }

  componentDidUpdate() {
    this.wow.sync()
  }

  render() {
    const { location, children } = this.props
    if (location.pathname === '/') {
    } else {
    }
    return (
      <div>
        <SiteNavi title={siteMetadata.title} {...this.props} />
        {children()}
				<Cnotice />
      </div>
    )
  }
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js